<script setup lang="ts">
/**
 * Bloc YouTube embed dans une card blanche arrondie.
 * Partagé entre /a/[slug] et /b/[slug].
 */
const props = defineProps<{
  url: string;
}>();

const embedUrl = computed(() =>
  props.url.replace('watch?v=', 'embed/').replace('youtu.be/', 'www.youtube.com/embed/'),
);
</script>

<template>
  <div class="bg-white dark:bg-[#141414] rounded-3xl shadow-[0_1px_3px_rgba(45,46,92,0.12)] p-4 md:p-6">
    <div class="aspect-video rounded-2xl overflow-hidden bg-black">
      <!-- `lazy` : le lecteur YouTube (~1 Mo de scripts) ne se charge qu'à
           l'approche — et jamais avec la home quand la page y est affichée
           en démo (DonateDemoSection). -->
      <iframe
        :src="embedUrl"
        loading="lazy"
        class="w-full h-full"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
  </div>
</template>
